import React from 'react'
import styles from "./Style.module.css"
import NoTimes from '../../Assets/Images/no-availability.svg'
import { BtnPrimary } from '../Buttons/BtnPrimary'

/**
 * Shown when an availability request fails (network/server error), as opposed
 * to NoAvailability, which is the genuine "no open slots" business state.
 */
export const AvailabilityError = ({ message, onRetry }) => (
  <div className={styles.noAvailability} role="alert">
    <img src={NoTimes} className={styles.icon} alt='' />
    <h5>Something Went Wrong</h5>
    <p>{message}</p>
    {onRetry && (
      <BtnPrimary label="Try Again" handleClick={onRetry} noIcon customClass="" />
    )}
  </div>
)
